import React from "react";
import { useTranslation } from "react-i18next";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import NewsCard from "../components/NewsCard";
// Local news metadata (array with one item for now)
import newsLocal from "../data/news.json";

import newsImg from "../images/news-img.png";


const News = () => {
  const { t } = useTranslation();
  // Using a static list of news stored in the repository.
  const data = newsLocal;

  return (
    <>
      <Navbar />
      <section className="page-title">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="caption-title">
                <h1>News</h1>
                <p>{t("news.title")}</p>
              </div>
            </div>
            <div className="col-lg-5">
              <img
                src={newsImg}
                alt=""
                className="img-fluid d-lg-block d-none"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="news-wrapper">
        <div className="container">
          <div className="row">
          {data.map((news) => (
            <NewsCard key={news.id} data={news} />
          ))}
          </div>
     
        </div>
      </section>
   
      <Footer />
    </>
  );
};

export default News;
